import { Injectable } from '@angular/core'
import { HttpRequest, HttpHandler, HttpInterceptor, HttpErrorResponse } from '@angular/common/http'
import { catchError, throwError } from 'rxjs'
import { ToastrService } from 'ngx-toastr'

@Injectable()
export class ErrorCatchingInterceptor implements HttpInterceptor {
    constructor(private toastr: ToastrService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler) {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                debugger
                let errorMsg = ''
                if (error.error instanceof ErrorEvent) {
                    console.log('This is client side error')
                    errorMsg = `Error: ${error.error.message}`
                } else {
                    debugger
                    console.log('This is server side error')
                    errorMsg = `Error Code: ${error.status},  Message: ${error.message}`

                    if (error.error?.errorMessage) {
                        errorMsg = error.error.errorMessage
                    }
                }
                this.toastr.error(errorMsg, 'Error')
                console.log(errorMsg)
                return throwError(() => error)
            })
        )
    }
}
